import React from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { colors } from '../../theme/color-palette';
import { Skeleton } from '@walmart-web/livingdesign-components';

const ShimmerTable = () => {
	const rows = [1, 2, 3, 4, 5, 6];

	return (
		<Box>
			<Table>
				<TableHead sx={{ '&:first-child td, &:first-child th': { border: 0 } }}>
					<TableRow
						sx={{
							backgroundColor: colors.WHITE_GREY,
						}}>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
						<TableCell>
							<Skeleton height="11px" width="104px" variant="rounded" />
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((row) => (
						<TableRow
							key={row.name}
							sx={{
								[`& .${tableCellClasses.root}`]: {
									padding: '15px',
								},
							}}>
							<TableCell component="th" scope="row">
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="100px" variant="rounded" />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Box>
	);
};

export default ShimmerTable;
